var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPadlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2484_601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.11 6.09L10.55 0L0 6.09V18.28L10.55 24.37L21.11 18.28V6.09Z",
    fill: "#4F80DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1198 4.76994C13.1598 3.63994 10.8398 4.30994 9.55977 6.65994L8.15977 9.50994C8.05977 9.70994 8.01977 9.96994 8.21977 10.0699L8.41977 9.93994C8.61977 10.0399 8.86977 9.95994 8.96977 9.74994L9.08977 9.55994C10.9298 5.06994 12.5398 4.65994 14.5598 5.56994C16.0998 6.26994 16.5798 8.33994 15.8098 9.83994L14.3198 12.7399L15.0398 13.1099L16.6098 10.0599C17.5798 8.17994 16.9598 5.80994 15.1298 4.75994L15.1198 4.76994Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5076 12.8985L7.95508 9.02038C7.37043 8.72017 6.65312 8.95076 6.35291 9.5354L3.75836 14.5882C3.45815 15.1728 3.68873 15.8902 4.27337 16.1904L11.8259 20.0685C12.4105 20.3687 13.1278 20.1381 13.428 19.5535L16.0226 14.5007C16.3228 13.916 16.0922 13.1987 15.5076 12.8985Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9099 14.79C11.1699 14.27 10.9699 13.64 10.4599 13.38C9.94995 13.12 9.30995 13.32 9.04995 13.83C8.85995 14.2 8.90995 14.63 9.14995 14.94L8.72995 15.75C8.60995 15.97 8.69995 16.25 8.92995 16.36C9.15995 16.47 9.42995 16.39 9.53995 16.16L9.95995 15.35C10.3499 15.35 10.7299 15.15 10.9199 14.78L10.9099 14.79Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -400.85,
    y: -293.85,
    width: 1340.7,
    height: 407.7,
    rx: 44.85,
    stroke: "black",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2484_601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.11,
    height: 24.37,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.8b431ebb.svg";
export { ForwardRef as ReactComponent };